import React, {useState} from 'react'
import PropTypes from 'prop-types';

import Footer from './Footer/Footer'
import Header from './Header/Header'
import SideBar from './SideBar/SideBar';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core'
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';

const useStyles= makeStyles(theme=>({
    root:{
        paddingTop: 56,//small sm
        // height: '100%',
        //height: 'calc(100%-56px)',
        //backgroundColor: 'green',
        [theme.breakpoints.up('sm')]:{
            paddingTop: 64,
            //height: 'calc(100%-64px)',
            // backgroundColor: 'yellow'
        },
        paddingLeft: 4,
        paddingRight: 4,
        display: 'flex',
        flex:1,
        flexDirection: 'column'
    },
    shiftContainer:{ //based on condition
        paddingLeft: 240+4
    },
    content: {
        height: '100%',
        width: '100%',
        //backgroundColor: 'yellow',
        display:'flex',
        flex:1
    },
    flexSpace: {
        flex:1
    }
}))
const Main = props => {
    const {children}= props

    const [openSideBar, setOpenSideBar]= useState(true)
    const sideBarHandlerOpen =()=>{
        setOpenSideBar(true)
    }
    const sideBarHandlerClose =()=>{
        setOpenSideBar(false)
    }

    const sideBarHandlerToggle =()=>{
        setOpenSideBar(!openSideBar)
    }

    const classes= useStyles()

    const theme= useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'),{
        defaultMatches : true
    })

    return (
        <PerfectScrollbar>
        <div 
            className= {classes.content}
        >
            {/* <Header sideBarHandler={sideBarHandlerOpen} sideBarStatus={openSideBar}/> */}
            
            <Header sideBarHandler={sideBarHandlerToggle} sideBarStatus={openSideBar}/>
            
            <SideBar 
            open={openSideBar}
            onCloseHandler= {sideBarHandlerClose }
            variant={isDesktop ? 'persistent' : 'temporary'}
            />
           
            <div className={clsx({
            [classes.root]: true,
             [classes.shiftContainer]: openSideBar ? (isDesktop ? true: false) : false,
            // [classes.shiftContainer]: isDesktop? true: false  //move only on desktop
            })}>
                {/* <h1>Main Layout </h1> */}
                {/* <h1>openSideBar {openSideBar? 'yes':'no'}</h1>
                <h2>isDesktop {JSON.stringify(isDesktop) }</h2>
                <h1>overaall {(isDesktop ? true : openSideBar? true: false)? 'yes':'no'}</h1> */}
               
                <div className={classes.flexSpace}>
                {children}
                </div>
               
                <Footer />
                
            </div>
           
        </div>
        </PerfectScrollbar>
    )
}

export default Main
Main.propTypes={
    children: PropTypes.node
}
